<template>
  <div class="border rounded">
    <div class="card-header mb-4">Details: </div>
    <div v-if="selectedSlot.start">
      <h4 class="card-title pl-2">Selected Time Slot:</h4>
      <p class="card-subtitle mb-3 pl-3"><strong>Date:</strong> {{ selectedSlot.start | asMoment | format('MMMM Do, YYYY') }}</p>
      <p class="card-subtitle mb-3 pl-3"><strong>Time:</strong> {{ selectedSlot.start | asMoment | format('h:mm') }} - {{ selectedSlot.end | asMoment | format('h:mm A') }}</p>
      <div v-if="selectedSlot.events != null" class="accordian" role="tablist">
        <b-card v-for="(event, index) in selectedSlot.events" :key="event.id" no-body class="mb-1 event-collapse-card">
          <b-card-header header-tag="header" class="p-0 event-header" role="tab">
            <button v-b-toggle="'collapse-event-' + index" class="btn btn-secondary block">
              Event Details
            </button>
          </b-card-header>
          <b-collapse :id="'collapse-event-' + index" visible accordion="my-accordion" role="tabpanel">
            <b-card-body class="event-body border">
              <b-card-text>
                <h4 class="card-title pl-1">Time Slot:</h4>
                <p class="card-subtitle mb-3 pl-3"><strong>Date:</strong> {{ event.start | asMoment | format('MMMM Do, YYYY') }}</p>
                <p class="card-subtitle mb-3 pl-3"><strong>Time:</strong> {{ event.start | asMoment | format('h:mm') }} - {{ event.end | asMoment | format('h:mm A') }}</p>
                <hr />

                <h4 class="card-title pl-1">Description:</h4>
                <p v-if="event.isBetterMyndEvent" class="card-subtitle mb-3 pl-3">{{ event.summary }}</p>
                <div v-else>
                  <p class="card-subtitle mb-3 pl-3">This Time Slot is being blocked by an external calendar</p>
                  <div v-if="event.profileName">
                    <p class="card-subtitle mb-3 pl-3"><strong>Profile: </strong></p>
                    <p class="card-subtitle mb-3 pl-4">{{ event.profileName }}</p>
                  </div>
                  <div v-if="event.calendarName">
                    <p class="card-subtitle mb-3 pl-3"><strong>Calendar:</strong></p>
                    <p class="card-subtitle mb-3 pl-4">{{ event.calendarName }}</p>
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <div v-if="canBeScheduled" class="card-footer">
        <b-button block variant="primary" @click="$emit('confirm-clicked', {})">
          Confirm
          <font-awesome-icon
            v-if="saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
        </b-button>
      </div>
    </div>
    <div v-else><h4 class="card-title text-center p-2">Please select valid time...</h4></div>
  </div>
</template>

<script>
export default {
    name: 'ClientEventCard',
    props: {
      selectedSlot: {
        type: Object,
        required: true
      },
      saving : {
        type: Boolean,
        require: true
      },
    },
      computed: {
        canBeScheduled() {
          return this.selectedSlot.events.length === 0 || (this.selectedSlot.events.length === 1 && this.selectedSlot.events[0].isOverridable);
        }
    }
}
</script>

<style lang="scss" scoped>
.card-header {
      background-color: $off-blue;
      font-size: 1.5rem;
    }

    .card-footer {
      background-color: $off-blue;
    }

    .event-collapse-card {
      border: 0;
    }
    .event-header {
      background-color: $off-blue;
      .btn {
        background-color: $off-blue;
      }
    }
    .event-body {
      background-color: $textbox-bg-color;
    }

    .btn {
      width: 100%;
    }

</style>
